import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["banner"]

  connect() {
    if (!this.hasConsent()) {
      this.bannerTarget.classList.remove('hidden')
    }
  }

  accept() {
    this.setConsent()
    this.bannerTarget.classList.add('hidden')
  }

  hasConsent() {
    return localStorage.getItem('cookieConsent') === 'accepted'
  }

  setConsent() {
    localStorage.setItem('cookieConsent', 'accepted')
  }
}
